<template>
	<div class="header">
		<div class="box flex-align" :style="{width}">
			<div class="left flex-align" :style="{marginLeft:width=='100%'?'10px':''}">
				<div class="logo flex-align">
					<img :src="`/assets/images/mainbody/logo.png?WebVersion=${$WebVersion}`" >
					<div class="text" v-if="mainbodyConfig.header_show_site_name">{{mainbodyConfig.site_name}}</div>
				</div>
				<div class="menuBox flex-align">
					<div class="active"></div>
					<router-link :class="{item:true,'flex-center':true,active:actIndex == item.value}"
						v-for="(item,index) in menuList" :key="index"
						:to="{path:item.path}">
						<el-badge :value="unreadCountView>0?unreadCountView:''" v-if="item.value == 4" color="rgba(255,42,42,1)">
							<div class="ellipsis" :title="$t(item.language, item.label)">{{$t(item.language, item.label)}}</div>
						</el-badge>
						<div v-else class="ellipsis" :title="$t(item.language, item.label)">{{$t(item.language, item.label)}}</div>
					</router-link>
					<!-- <div :class="{item:true,'flex-center':true,active:actIndex == item.value}" 
					v-for="(item,index) in menuList" :key="index"
					@click="clickMenu(item)"
					>
						<div class="ellipsis" :title="$t(item.language)">{{$t(item.language)}}</div>
					</div> -->
				</div>
			</div>
			<div class="right flex-align">
				<div class="searchBox flex-center" :style="{width: width=='100%'?'300px':''}">
					<el-input
						class="searchKeyword"
						:style="{width: width=='100%'?'298px':''}"
						v-model="searchKeyword"
						:placeholder="$t('components.layout.header_searchPlaceholder', '搜索比赛、频道…')"
						@keyup.enter="doSearch"
						>
						<template #prepend>
							<div class="icon-search flex-center">
								<img src="@/assets/images/icon-search.png">
							</div>
						</template>
						<template #append>
							<el-button class="search-btn flex-center" @click.stop="doSearch">{{$t('components.layout.header_search', '搜索')}}</el-button>
						</template>
					</el-input>
				</div>
				<div class="operate flex-align" style="--lineClamp:1;" :style="{marginLeft: width=='100%'?'15px':''}">
					<el-dropdown trigger="click" @command="handleLanguageCommand">
						<div class="language-switch flex-align">
							<div class="flagBox flex-center">
								<img class="flag" :src="currentLanguageFlag" @error="e=>e.target.src=require('@/assets/images/icon-language.png')" >
							</div>
							<el-icon><CaretBottom /></el-icon>
						</div>
						<template #dropdown>
							<el-dropdown-menu>
								<el-dropdown-item
									v-for="lang in languageOptions"
									:key="lang.key"
									:command="lang.key"
									:disabled="lang.key === currentLanguage"
								>
									{{lang.label}}
								</el-dropdown-item>
							</el-dropdown-menu>
						</template>
					</el-dropdown>
					<el-popover placement="bottom" width="302" popper-class="popoverContent header">
						<template #reference>
							<div class="item flex-column flex-center">
								<div class="icon">
									<img src="@/assets/images/icon-weixin-line.png" >
								</div>
								<div class="text ellipsis-multiline">{{$t('components.layout.header_officialAccount', '公众号')}}</div>
							</div>
						</template>
						<div class="officialAccount">
							<div class="top flex-column flex-align">
								<div class="title">{{mainbodyConfig.site_name}}公众号</div>
								<div class="subTitle">扫码关注{{mainbodyConfig.site_name}}公众号</div>
								<div class="qrCodeBox flex-center">
									<img :src="`/assets/images/mainbody/oa_account_qr.png?WebVersion=${$WebVersion}`" >
								</div>
							</div>
							<div class="bottom flex-center flex-column">
								<div>微信扫码关注</div>
							</div>
						</div>
					</el-popover>
					<router-link class="item flex-column flex-center" to="">
						<el-popover placement="bottom" :width="downloadPopupStyle==1?344:302" :popper-class="`header popoverContent ${downloadPopupStyle==2?'style2':''}`">
							<template #reference>
								<div class="item flex-column flex-center">
									<div class="icon">
										<img src="@/assets/images/icon-download.png" >
									</div>
									<div class="text ellipsis-multiline">{{$t('components.layout.header_download', '下载')}}</div>
								</div>
							</template>
							<div class="downloadPopupContent flex-column style1" :style="`background:url(/assets/images/mainbody/downloadPopup.png?WebVersion=${$WebVersion});background-size:100%;`"
							v-if="downloadPopupStyle==1">
								<div class="top">
									<div class="info flex-column">
										<img class="logo" :src="`/assets/images/mainbody/logo-rect.png?WebVersion=${$WebVersion}`" >
										<div class="h2">{{mainbodyConfig.site_name}}APP</div>
										<div class="tip flex-column">
											<span>随时随地观看</span>
											<span>专业赛事直播</span>
										</div>
									</div>
								</div>
								<div class="bottom flex-align">
									<div class="qrCodeBox flex-center">
										<img :src="`/assets/images/mainbody/app_download_url.png?WebVersion=${$WebVersion}`" >
									</div>
									<div class="right flex-column">
										<div class="h2">扫码下载{{mainbodyConfig.site_name}}APP</div>
										<div class="tip">下载客户端，浏览更方便</div>
									</div>
								</div>
							</div>
							<div v-else-if="downloadPopupStyle==2" class="downloadPopupContent flex-column style2">
								<div class="top flex-column flex-align">
									<div class="title">{{mainbodyConfig.site_name}}APP</div>
									<div class="subTitle">扫码下载{{mainbodyConfig.site_name}}APP</div>
									<div class="qrCodeBox flex-center">
										<img :src="`/assets/images/mainbody/app_download_url.png?WebVersion=${$WebVersion}`" >
									</div>
								</div>
								<div class="bottom flex-center">
									<el-link class="download" :href="startUp.configData?.androidDownLoad" underline="never" target="_blank">安卓下载</el-link>
									<el-link class="download" :href="startUp.configData?.iosDownLoad" underline="never" target="_blank">IOS下载</el-link>
								</div>
							</div>
							<div v-else-if="downloadPopupStyle==3" class="downloadPopupContent flex-column style3">
								<div class="top flex-column flex-align">
									<div class="title">{{mainbodyConfig.site_name}}APP</div>
									<div class="subTitle">扫码下载{{mainbodyConfig.site_name}}APP</div>
									<div class="qrCodeBox flex-center">
										<vue-qr style="vertical-align: middle;" v-if="installGuideUrl"
											:text="installGuideUrl"
											:size="182"
											:logoMargin="2"
											level="H"
											ref="roomQRcodeRef"
										></vue-qr>
									</div>
								</div>
								<div class="bottom flex-center flex-column">
									<div>用手机浏览器扫一扫</div>
									<div>精彩马上呈现</div>
								</div>
							</div>
						</el-popover>
					</router-link>
					<div class="item flex-column flex-center" >
						<template v-if="userInfo.id">
							<el-dropdown @command="handleCommand" trigger="hover" ref="dropdown">
								<div class="userInfo flex-column flex-center">
									<!-- <div class="icon avatar">
										
									</div>
									<div class="text ellipsis-multiline">{{userInfo.nickName}}</div> -->
									<el-image :src="ImageParameterSplicing(userInfo.photo||'',100)" fit="cover" @click="handleCommand('personal')">
										<template #error>
											<div class="image-slot flex-center">
												<img src="@/assets/images/defaultAvatar.png">
											</div>
										</template>
									</el-image>
								</div>
								<template #dropdown>
									<el-dropdown-menu>
										<el-dropdown-item command="personal">{{$t('route.memberPersonal', '个人中心')}}</el-dropdown-item>
										<el-dropdown-item command="customerService" v-if="userInfo.id">专属客服</el-dropdown-item>
										<el-dropdown-item divided command="signout">退出登录</el-dropdown-item>
									</el-dropdown-menu>
								</template>
							</el-dropdown>
						</template>
						<template v-else>
							
							<div @click="toLogin">
								<div class="icon">
									<img src="@/assets/images/icon-login_register.png" >
								</div>
								<div class="text ellipsis-multiline">{{$t('other.common.login')}}/{{$t('other.common.register')}}</div>
							</div>
						</template>
					</div>
				</div>
			</div>
		</div>
		<!-- 登录弹窗 -->
		<el-dialog
			v-model="loginDialog.visible"
			@close="loginDialogClose"
			:class="{ loginDialog:true, compact:isMyLiveRoomChatRoute }"
			header-class="headerClass"
			body-class="bodyClass"
			:show-close="false"
			append-to-body
			:width="loginDialogWidth"
			>
			<loginView @success="loginSuccess" @close="loginDialog.visible = false" :mode="1" :compact="isMyLiveRoomChatRoute"></loginView>
		</el-dialog>
	</div>
</template>

<script setup>
	import loginView from "@/components/login";
	import vueQr from "vue-qr/src/packages/vue-qr.vue";
	import {ref,reactive,getCurrentInstance,onMounted,onUnmounted,computed,watch,inject} from "vue";
	const chatManager = inject('chatManager');
	let {proxy} = getCurrentInstance();
	let props = defineProps({
		width:{
			type:[String,Number],
			default:''
		}
	});
	let downloadPopupStyle = ref(3);
	let width = ref('1240px');
	watch(()=>props.width,(v)=>{
		if(v!==''){
			if(/(px|%)$/.test(v)){
				width.value = v;
			}else{
				width.value = v + 'px';
			}
		}
	},{immediate:true})
	import {useStore} from '@/store';
	let store = useStore();
	const languageStorageKey = 'language';
	const languageOptions = [
		{ key: 'zh', label: '中文', short:'CN', flag:'' },
		{ key: 'en', label: 'English', short:'GB', flag:'' },
		{ key: 'vi', label: 'Tieng Viet', short:'VN', flag:'' },
	];
	languageOptions.forEach(e=>{
		e.flag = require(`@/assets/images/national_flag_svg/${e.short.toLocaleLowerCase()}.svg`);
	})
	let currentLanguage = ref('zh');
	// if(proxy.process_env_NODE_ENV != 'development'){
	// 	let findex = languageOptions.findIndex(e=>e.key == 'vi');
	// 	if(findex>-1){
	// 		languageOptions.splice(findex,1);
	// 	}
	// }
	const currentLanguageLabel = computed(() => {
		return languageOptions.find(e => e.key === currentLanguage.value)?.label || '中文';
	});
	const currentLanguageFlag = computed(() => {
		return languageOptions.find(e => e.key === currentLanguage.value)?.flag;
	});
	const syncCurrentLanguage = () => {
		const locale = proxy.$i18n?.locale;
		const localeValue = typeof locale === 'string' ? locale : locale?.value;
		if (localeValue && languageOptions.some(e => e.key === localeValue)) {
			currentLanguage.value = localeValue;
			return;
		}
		const saved = proxy.localStorage.getItem(languageStorageKey);
		if (languageOptions.some(e => e.key === saved)) {
			currentLanguage.value = saved;
		}
	};
	const handleLanguageCommand = (langKey) => {
		if (!languageOptions.some(e => e.key === langKey)) return;
		currentLanguage.value = langKey;
		proxy.$i18n.locale = langKey;
		proxy.$moment.locale(langKey === 'zh' ? 'zh-cn' : langKey);
		proxy.localStorage.setItem(languageStorageKey, langKey);
	};
	let menuList = [
		{value:0,label:'首页',path:'/home',language:'route.home'},
		{value:1,label:'赛程',path:'/schedule',language:'route.schedule'},
		{value:2,label:'直播',path:'/live',language:'route.live'},
		{value:3,label:'资讯',path:'/information',language:'route.information'},
		{value:4,label:'聊天',path:'/message',language:'route.msg'},
	];
	let userInfo = computed(()=>store.state.user);
	let startUp = computed(()=>store.state.startUp);
	let isMyLiveRoomChatRoute = computed(()=>/^\/MyliveRoomChat(\/|$)/i.test(proxy.$route.path || window.location.pathname || ''));
	let loginDialogWidth = computed(()=>isMyLiveRoomChatRoute.value ? '280px' : '588px');
	let actIndex = ref(0);
	let clickMenu = (item)=>{
		actIndex.value = item.value;
		proxy.$router.push({path:item.path});
	}
	let searchKeyword = ref('');
	
	let setMenuAct = (path) => {
		let has = menuList.find(e=>new RegExp('^'+e.path).test(path));
		if (has) {
			actIndex.value = has.value;
		} else {
			actIndex.value = -1;	
		}
		if (path == '/home') {
			actIndex.value = 0;
		}
	}
	watch(() => proxy.$route.path, (path) => {
		setMenuAct(path);
	}, { immediate: true });
	watch(()=>userInfo.value.id,(val,oldVal)=>{
		if(oldVal && !val){//用户退出登录
			unreadCount.value = 0;
			unreadCount_apply.value = 0;
		}
	});
	// let friendApplication = reactive({});
	// watch(()=>friendApplication.unreadCount,(unreadCount)=>{
	// 	if(unreadCount!=undefined){
	// 		unreadCount_apply.value = unreadCount||0;
	// 	}
	// })
	proxy.$bus.on('showLoginPopup',()=>{
		toLogin();
	});
	let chatRegistration = null;
	onMounted(async()=>{
		getInstallGuideUrl();
		syncCurrentLanguage();
		
		proxy.$bus.on('unreadCount',(v)=>unreadCount.value = v||0);
		if(userInfo.value.id){
			await loginChat();
		}
		proxy.$bus.on('customerService',(msg)=>{
			customerService(msg);
		});
	})
	watch(() => proxy.$i18n?.locale, () => {
		syncCurrentLanguage();
	});
	let loginChat = async()=>{
		await chatManager.login({
			userId:userInfo.value.id, 
			request: proxy.request,
		});
		chatRegistration = chatManager.registerEvents([
			{
				event:chatManager.TencentCloudChat.EVENT.FRIEND_APPLICATION_LIST_UPDATED,
				handler:(e)=>{
					console.log('好友申请列表更新事件-hader页面',e);
					getFriendApplicationList();
				}
			},
			{
				event:chatManager.TencentCloudChat.EVENT.CONVERSATION_LIST_UPDATED,//监听会话列表更新事件
				handler:async(e)=>{
					console.log("监听会话列表更新事件-index页面",e);
					if((await chatManager.getChatClient()).isReady()){
						getServerConversations().then(()=>{})
					}
				}
			}
		]);
		if((await chatManager.getChatClient()).isReady()){
			await getServerConversations().then(()=>{})
			// await proxy.awaitTime(500);
			getFriendApplicationList();//获取申请列表
		}
	}
	onUnmounted(() => {
		if (chatRegistration?.unregister) {
			chatRegistration.unregister(); // 直接调用返回的注销函数
		}
		proxy.$bus.off('showLoginPopup');
		proxy.$bus.off('unreadCount');
		proxy.$bus.off('customerService');
	})
	let unreadCountView = computed(()=>unreadCount.value + unreadCount_apply.value);
	let unreadCount = ref(0);
	let unreadCount_apply = ref(0);
	let toLogin = ()=>{
		loginDialog.visible = true;
		// proxy.$router.push('/signIn');
	}
	let loginDialog = reactive({
		visible:false,
		
	})
	let loginDialogClose = (done)=>{
		proxy.$bus.emit('closeLoginPop');//关闭弹窗
	}
	let loginSuccess = (userInfo)=>{
		console.log(userInfo);
		proxy.$message({
			type: "success",
			duration: 1000,
			message: "登录成功!",
		});
		loginDialog.visible = false;
	}
	let doSearch = ()=>{
		let query = {
			keywords:searchKeyword.value,
		}
		if(proxy.$route.query.currType!=undefined){
			Object.assign(query,{
				currType:proxy.$route.query.currType
			})
		}
		let path = '/search';
		// if(searchKeyword.value == '8888'){
		// 	store.action.set('earlyAccess',true);
		// 	if(/member/.test(proxy.$route.path)){
		// 		path = '/member2';
		// 		query = {};
		// 	}else{
		// 		proxy.$router.replace({
		// 			path:proxy.$route.path,
		// 			query:Object.assign({},proxy.$route.query,{earlyAccess:true}),
		// 		}).then(()=>{
		// 			searchKeyword.value = '';
		// 		})
		// 		return;
		// 	}
		// }
		console.log(query);
		proxy.$router.push({
			path,
			query
		}).then(()=>{
			searchKeyword.value = '';
		})
	}
	
	let handleCommand = (command)=>{
		switch (command) {
			case 'personal':
				proxy.$router.push('/member2/personal/profile/basicInfo');
			break;
			case 'customerService':
				customerService();
			break;
			case 'signout':
				proxy.$confirm('确认退出吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					confirmButtonClass: 'confirmButtonClass'
				}).then(() => {
					store.action.user.resetUserStore();
					proxy.localStorage.removeItem('userInfo');
					proxy.localStorage.removeItem('token');
					proxy.$message({
						type: 'success',
						duration: 1000,
						message: '退出成功!'
					});
					if(/\/message/.test(proxy.$route.path)){
						proxy.$router.replace('/');
					}
				}).catch((e) => {console.log(e)});
			break;
		}
	}
	let conversations = reactive([]);
	// 查询会话列表
	let getServerConversations = async ()=>{
		try{
			var res = await chatManager.getConversationList();
			console.log('查询会话列表',res);
			// 全量的会话列表，用该列表覆盖原有的会话列表
			let conversationList = res.data.conversationList;
			conversationList = conversationList.filter(e=>(e.type == 'C2C' || e.type == 'GROUP'&&e.groupProfile.type != 'AVChatRoom')&&e.type != chatManager.TencentCloudChat.TYPES.CONV_SYSTEM);
			conversations.length = 0;
			// conversationList.forEach((e,i)=>e.sort = i);
			let isPinnedArr = conversationList.filter(e=>e.unreadyCount && e.type != chatManager.TencentCloudChat.TYPES.CONV_SYSTEM);
			let notPinnedArr = conversationList.filter(e=>!e.unreadyCount && e.type != chatManager.TencentCloudChat.TYPES.CONV_SYSTEM);
			let systemMsg = conversationList.filter(e=>e.type == chatManager.TencentCloudChat.TYPES.CONV_SYSTEM);
			let pArr = [];
			isPinnedArr.concat(notPinnedArr).forEach(e=>{
				conversations.push(e);
			});
			console.log('查询会话列表',conversations);
			unreadCount.value = conversations.filter(e=>e.unreadCount&&e.messageRemindType == chatManager.TencentCloudChat.TYPES.MSG_REMIND_ACPT_AND_NOTE).map(e=>e.unreadCount).reduce((a,b)=>a+b,0);
			console.log('会话列表中的未读数：',unreadCount.value);
		}catch(err){
			console.log(err);
		}finally{
		}
	}
	// 向我申请的列表
	let appliedToMeList = reactive([]);
	let getFriendApplicationList = async()=>{
		let promise = (await chatManager.getChatClient()).getFriendApplicationList();
		return promise.then(function(imResponse) {
			// friendApplicationList - 好友申请列表 - [FriendApplication]
			// FriendApplication 数据结构详情请参考 https://web.sdk.qcloud.com/im/doc/v3/zh-cn/FriendApplication.html
			// unreadCount - 好友申请的未读数
			const { friendApplicationList, unreadCount } = imResponse.data;
			unreadCount_apply.value = unreadCount||0;
			// proxy.clearObject(friendApplication);
			// Object.assign(friendApplication,imResponse.data);
		});
	}
	let customerService = async(msg)=>{
		if(typeof msg == 'string' || !msg){
			if(!msg)msg = '你好';
			if(!userInfo.value.customerUserID){
				let tipInfo = proxy.$message({
					message:'正在分配客服...',
					type:'info',
					duration:0,//不自动关闭
				});
				// 去分配客服
				assigningCustomer().then(()=>{
					handleCustomerService(msg).finally(()=>{
						tipInfo.close();
					});
				}).catch(err=>{
					tipInfo.close();//手动关闭
				})
			}else{
				// 存在客服ID
				let tipInfo = proxy.$message({
					message:'正在发起会话...',
					type:'info',
					duration:0,//不自动关闭
				});
				// 发起会话
				handleCustomerService(msg).then(async()=>{
					
				}).finally(()=>{
					tipInfo.close();//手动关闭
				});
			}
		}else{
			// 联系主播专员
			let isFriend = await checkFriend(msg.userID);
			if(isFriend){
				let tipInfo = proxy.$message({
					message:'正在发起会话...',
					type:'info',
					duration:0,//不自动关闭
				});
				// 发起会话
				handleCustomerService(msg).then(async()=>{
					
				}).finally(()=>{
					tipInfo.close();//手动关闭
				});
			}else{//不是好友，去添加
				(await chatManager.getChatClient()).addFriend({
					to: msg.userID,
					source: 'AddSource_Type_Web',
					wording: msg.message,
					type: chatManager.TencentCloudChat.TYPES.SNS_ADD_TYPE_BOTH,
				}).then((imResponse)=> {
					// 添加好友的请求发送成功
					const { code } = imResponse.data;
					if (code === 30539) {
						// 30539 说明 user1 设置了【需要经过自己确认对方才能添加自己为好友】
						// 此时 SDK 会触发 TencentCloudChat.EVENT.FRIEND_APPLICATION_LIST_UPDATED 事件
						if(msg.type == 'LiveRoomCreate'){
							proxy.$message.success('主播审核专员会第一时间联系您');
						}else{
							proxy.$message.success('已向主播审核专员发起会话申请');
						}
					} else if (code === 0) {
						// 0 说明 user1 设置了【允许任何人添加自己为好友】
						// 此时 SDK 会触发 TencentCloudChat.EVENT.FRIEND_LIST_UPDATED 事件
						let tipInfo = proxy.$message({
							message:'正在发起会话...',
							type:'info',
							duration:0,//不自动关闭
						});
						// 发起会话
						handleCustomerService(msg).then(async()=>{
							
						}).finally(()=>{
							tipInfo.close();//手动关闭
						});
					}
				}).catch((imError)=> {
					console.warn('addFriend error:', imError); // 添加好友失败的相关信息
					if(imError?.code == 30010){
						proxy.$message.error('自己的好友数已达系统上限。');
					}else if(imError?.code == 30014){
						proxy.$message.error('对方的好友数已达系统上限。');
					}
				});
			}
			
		}
		
	}
	
	let checkFriend = async(userID)=>{
		let checkFriendRes = await (await chatManager.getChatClient()).checkFriend({
			userIDList:[userID],
			type:chatManager.TencentCloudChat.TYPES.SNS_CHECK_TYPE_BOTH
		})
		let successUserIDList = checkFriendRes?.data.successUserIDList||[];
		let has = successUserIDList.filter(u=>u.relation == chatManager.TencentCloudChat.TYPES.SNS_TYPE_BOTH_WAY).find(u=>u.userID == userID);
		return !!has;
	}
	
	let assigningCustomer = ()=>{
		return proxy.request({
			url:`AssignCustomer`,
			method:'post',
			notips:true,
		}).then(({data})=>{
			if(data.code == 200){
				console.log('分配客服结果：',data.data);
				proxy.$message.success('分配成功');
				store.action.user.updateUser({customerUserID:data.data.customerID});
			}
		}).catch(err=>{
			console.log('分配客服失败：',err);
		})
	}
	let chatLogin = (kickouted)=>{
		return chatManager.login({
			userId:userInfo.value.id, 
			request: proxy.request,
			kickouted,
		}).then(res=>{
			console.log('chatManager.login:',res);
			if(!res.succ){
				setTimeout(()=>{
					console.log('正在重试登录腾讯chat');
					chatManager.login({
						userId:userInfo.value.id, 
						request: proxy.request,
						kickouted,
					});
				},5000)
			}else{
				
			}
		}).catch(err=>{
			console.log('chatManager.login-err:',err);
			
		})
	}
	let retrysendMessageCount = 0;
	let handleCustomerService = async(msg)=>{
		let _msg = null;
		let to = userInfo.value.customerUserID;
		if(typeof msg == 'string'){
			_msg = msg;
		}else{
			_msg = msg.message;
			to = msg.userID;
		}
		if(!chatManager.isLoggedIn()){
			await chatLogin();
		}
		// 等待ready
		await new Promise((resolve,reject)=>{
			(async function checkReady(){
				if((await chatManager.getChatClient()).isReady()){
					resolve();
				}else{
					await proxy.awaitTime(300);
					checkReady();
				}
			})()
		})
		// 发送文本消息。
		const option = {
			to,
			conversationType: chatManager.TencentCloudChat.TYPES.CONV_C2C,
			// 消息优先级，用于群聊。如果某个群的消息超过了频率限制，后台会优先下发高优先级的消息
			// priority: TencentCloudChat.TYPES.MSG_PRIORITY_NORMAL,
			payload: {
				text: _msg??'你好',
			},
			// 如果您发消息需要已读回执，需购买旗舰版套餐，并且创建消息时将 needReadReceipt 设置为 true
			needReadReceipt: true,
			cloudCustomData:'',
		};
		try{
			// sendLoading.value = true;
			let msg = (await chatManager.getChatClient()).createTextMessage(option);
			console.log("createTextMessage", JSON.parse(JSON.stringify(msg)));
			retrysendMessageCount++;
			await chatManager.sendMessage(msg).then(async(res) => {
				let message = (res.data.message);
				console.log('消息发送成功',message);
				jumpToChat(userInfo.value.customerUserID);
			}).catch(async err=>{
				console.log("Send message fail", err);
				if(retrysendMessageCount>1){
					return 	proxy.$message.error('发起会话失败，请稍后重试');
				}
				proxy.$message.info('重新分配客服中');
				//重新分配客服
				let retryQDUC = 0;
				let maxRetry = 1;
				(async function retryQDUCfn(){
					assigningCustomer().then(()=>{
						handleCustomerService(msg);
					}).catch(async err=>{
						retryQDUC++;
						if(retryQDUC<=maxRetry){
							await proxy.awaitTime(500);
							retryQDUCfn();//
						}else{
							proxy.$message.error('分配专属客服失败，请稍后重试');
						}
					})
				})()
			})
		}catch(err){
			console.log('检查option',option);
			console.log("发送信息失败-try-catch:", err);
		}finally{
			// sendLoading.value = false;
		};
	}
	
	let jumpToChat = async(customerUserID)=>{
		let profile = await (await chatManager.getChatClient()).getUserProfile({userIDList:[customerUserID]});
		let o = {
			conversationID:chatManager.TencentCloudChat.TYPES.CONV_C2C+customerUserID,
			type:chatManager.TencentCloudChat.TYPES.CONV_C2C,
			unreadCount:0,
			userProfile:profile?.data[0]||{userID:customerUserID},
		}
		store.action.currChatUser.set(o);
		// 跳转聊天界面
		proxy.$router.push({
			path:'/message/msg',
			query:{
				// customerUserID
			}
		})
	}
	let installGuideUrl = ref('');
	watch(()=>startUp.value,()=>{
		getInstallGuideUrl();
	},{deep:true})
	// 当前协议://{H5域名}/openInstallGuide
	let getInstallGuideUrl = ()=>{
		if(!Object.keys(startUp.value).length)return;
		if(startUp.value.safeDomains?.length==0) {
			console.log('未配置服务地址，敬请期待！')
			return;
		}
		let protocol = window.location.protocol;
		let _safeDomains = startUp.value.safeDomains?.map(e=>e.replace(RegExp('https{0,1}://'), ''));
		let safeDomain = _safeDomains[0];
		installGuideUrl.value = `${protocol}//${safeDomain}/openInstallGuide`;
	}
	
</script>

<style>
	.el-dialog{
		padding: 0!important;
		background:transparent!important;
		box-shadow:unset!important;
	}
	.headerClass,.bodyClass{
		padding: 0!important;
		background:transparent;
		box-shadow:unset!important;
	}
</style>
<style lang="scss" scoped>
	.header{
		width: 100%;
		height:73px;
		position:fixed;
		left: 0;
		top:0;
		z-index: 999;
		box-shadow: 0 1px 2px #eee;
		background: rgba(255, 255, 255, 0.85);
		backdrop-filter: blur(10px);
		.box{
			min-width: 1240px;
			height:73px;
			margin: 0 auto;
			justify-content: space-between;
			.left{
				.logo{
					img{
						width:auto;
						height:45px;
					}
					.text{
						font-family: BigruixianBlackGBV;
						font-weight: 400;
						font-size: 40px;
						color: #000000;
						display: inline-block;
						margin-right: 20px;
					}
				}
				.menuBox{
					.item{
						width:95px;
						height: 45px;
						font-family: PingFang-SC-Bold;
						font-size: 18px;
						color: #5E647D;
						cursor: pointer;
						position: relative;
						&.active{
							color: #000;
							font-weight: bold;
							&:after{
								position: absolute;
								bottom: 3px;
								left:50%;
								transform:translateX(-50%);
								content: '';
								width: 20px;
								height: 5px;
								background: var(--qx2-primary-linearGradient-color);
							}
						}
					}
				}
			}
			.right{
				.searchBox{
					margin-left:auto;
					width: 260px;
					height: 38px;
					background: var(--qx2-primary-linearGradient-color);
					box-shadow: 0px 3px 11px rgba(97,97,97,0.08);
					border-radius: 19px;
					.searchKeyword{
						width: 258px;
						height: 36px;
						background: rgba(254,254,254,0.39);
						border-radius: 19px;
						background: #fff;
						.icon-search{
							margin-left: 12px;
							img{
								width:20px;
							}
						}
						.search-btn{
							// width: 50px;
							border-radius: 19px;
							background: var(--qx2-primary-linearGradient-color);
							color:#fff;
							margin-right:2px;
							box-shadow:unset;
							border:unset;
						}
						:deep(.el-input-group__prepend){
							box-shadow:unset;
							background-color:unset;
							padding:unset;
						}
						:deep(.el-input__wrapper){
							box-shadow:unset;
							background-color:unset;
						}
						:deep(.el-input-group__append){
							padding:unset;
							border-radius: 19px;
							
						}
					}
				}
				.operate{
					flex:1;
					.language-switch{
						margin-left:15px;
						width: auto;
						height: 38px;
						justify-content: space-between;
						cursor:pointer;
						.flagBox{
							width: 38px;
							height: 38px;
							background: rgba(219,243,224,1);
							border-radius: 19px;
							.flag{
								width:20px;
								height:20px;
								object-fit:scale-down;
							}
						}
						.el-icon{
							margin-left:5px;
							font-size: 14px;
						}
					}
					.item{
						width: 65px;
						min-height:38px;
						cursor: pointer;
						.userInfo{
							outline: none;
							width: 65px;
							min-height:38px;
							.el-image{
								width: 38px;
								height: 38px;
								border-radius:50%;
								box-shadow: 0 0 3px #aaa;
								.image-slot{
									width:100%;
									height:100%;
									img{
										width:100%;
										height:100%;
										border-radius:50%;
									}
								}
							}
						}
						.icon{
							width: 100%;
							height: 18px;
							text-align: center;
							img{
								width:18px;
							}
							&.lang-icon-wrap{
								display:flex;
								align-items:center;
								justify-content:center;
								.lang-icon{
									display:inline-block;
									width:16px;
									height:16px;
									line-height:16px;
									// border-radius:50%;
									// font-size:12px;
									// font-weight:700;
									// color:#2d9982;
									// background:#c1f3e7;
								}
							}
							&.avatar{
								margin-top:-3px;
								width: 26px;
								height: 26px;
								.el-image{
									width: 100%;
									height:100%;
									object-fit: cover;
									overflow: hidden;
									border-radius: 50%;
									border: 1px solid #eee;
									.image-slot{
										width: 100%;
										height:100%;
										img{
											width: 100%;
											height:100%;
											object-fit: cover;
											border-radius: 50%;
										}
									}
								}
							}
						}
						.text{
							width: 100%;
							text-align: center;
							font-size: 12px;
						}
					}
				}
			}
		}
	}
</style>
<style lang="scss">
	.popoverContent.header{
		border: unset !important;
		box-sizing: border-box;
		/* min-width: 150px; */
		/* overflow-wrap: break-word; */
		padding: unset !important;
		&.style2{
			--el-bg-color-overlay:#1D1E1F;
			// .el-popper__arrow{
			// 	&:before{
			// 		background:#1D1E1F;	
			// 	}
			// }
		}
		.downloadPopupContent{
			width: 100%;
			&.style1{
				// background: url('@/assets/images/mainbody/downloadPopup.png');
				background-size:100% ;
				.top{
					width:100%;
					height:182px;
					.info{
						width:170px;
						padding-left: 34px;
						.logo{
							margin-top:30px;
							width:46px;
							height:46px;
						}
						.h2{
							margin-top: 14px;
							font-family: BigruixianBlackGBV;
							font-weight: 400;
							font-size: 16px;
							color: #000000;
						}
						.tip{
							margin-top: 10px;
							font-family: PingFang-SC-Bold;
							font-size: 13px;
							color: #000000;
						}
					}
				}
				.bottom{
					width:100%;
					height:110px;
					.qrCodeBox{
						width:84px;
						height:84px;
						margin-left:13px;
						background: rgba(255,255,255,1);
						box-shadow: 0px 0px 6px rgba(0,45,0,0.16);
						border-radius: 4px;
						img{
							width:83px;
						}
					}
					.right{
						
						flex:1;
						padding-left:25px;
						.h2{
							font-family: BigruixianBlackGBV;
							font-weight: 400;
							font-size: 16px;
							color: #000000;
						}
						.tip{
							font-family: PingFang-SC-Bold;
							font-size: 13px;
							color: #000000;
						}
					}
				}
			}
			&.style2{
				background:#1D1E1F;
				width:302px;
				border-radius:6px;
				.top{
					.title{
						margin-top:20px;
						// font-family: BigruixianBlackGBV1.0;
						font-weight: 400;
						font-size: 20px;
						color: #FFFFFF;
					}
					.subTitle{
						margin-top:8px;
						// font-family: PingFang-SC-Bold;
						font-weight:bold;
						font-size: 14px;
						color: #8D8F94;
					}
					.qrCodeBox{
						margin-top:14px;
						width: 142px;
						height: 142px;
						background: #fff;
						box-shadow: 0px 0px 6px rgba(0,45,0,0.16);
						border-radius: 4px;
						img{
							width:116px;
							height:116px;
						}
					}
				}
				.bottom{
					margin:11px 0 14px 0;
					justify-content:space-evenly;
					.download{
						width: 45%;
						height: 40px;
						border-radius: 20px;
						background: var(--qx2-primary-linearGradient-color);
						color: #fff;
						font-size: 14px;
						font-weight:bold;
						border: unset;
						box-shadow: unset;
					}
				}
			}
			&.style3{
				background:#fff;
				width:302px;
				border-radius:6px;
				.top{
					.title{
						margin-top:20px;
						// font-family: BigruixianBlackGBV1.0;
						font-weight: bold;
						font-size: 20px;
						color: #020202;
					}
					.subTitle{
						margin-top:8px;
						// font-family: PingFang-SC-Bold;
						font-weight:400;
						font-size: 14px;
						color: #8D8F94;
					}
					.qrCodeBox{
						margin-top:14px;
						width: 142px;
						height: 142px;
						background: #fff;
						box-shadow: 0px 0px 6px rgba(0,45,0,0.16);
						border-radius: 4px;
						img{
							width:142px;
							height:142px;
						}
					}
				}
				.bottom{
					margin:11px 0 14px 0;
					color: #8D8F94;
				}
			}
		}
		.officialAccount{
			background:#fff;
			width:302px;
			height:295px;
			border-radius:6px;
			.top{
				.title{
					margin-top:20px;
					// font-family: BigruixianBlackGBV1.0;
					font-weight: bold;
					font-size: 20px;
					color: #020202;
				}
				.subTitle{
					margin-top:8px;
					// font-family: PingFang-SC-Bold;
					font-weight:400;
					font-size: 14px;
					color: #8D8F94;
				}
				.qrCodeBox{
					margin-top:14px;
					width: 142px;
					height: 142px;
					background: #fff;
					box-shadow: 0px 0px 6px rgba(0,45,0,0.16);
					border-radius: 4px;
					img{
						width:116px;
						height:116px;
					}
				}
			}
			.bottom{
				margin:11px 0 14px 0;
				color: #8D8F94;
			}
		}		
	}
</style>